import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../context/AuthProvider'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import ModalWrapper from '../../../components/Modals/ModalWrapper';
import FontSizes from '../../../constants/FontSizes';
import { MainColors } from '../../../constants/Colors';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const VotingAliasModal = (props) => {
    const [isAliasHidden, setIsAliasHidden] = useState(true);
    const { voterAlias } = useContext(AuthContext)

    useEffect(() => {
        setIsAliasHidden(true);
    }, [props.onModalBackgroundPressed]);

    return (
        <ModalWrapper visible={props.visible} onModalBackgroundPressed={props.onModalBackgroundPressed}>
            <View style={styles.container}>
                <View style={styles.headerContainer}>
                    <Text style={styles.title}>My Voting Alias</Text>
                    <TouchableOpacity onPress={props.onCloseButtonPressed} accessibilityLabel='Close'>
                        <MaterialCommunityIcons name="close" size={16} color={MainColors.mediumGray} />
                    </TouchableOpacity>
                </View>

                <View style={styles.contentContainer}>
                    {isAliasHidden ? (
                        <Text style={styles.hiddenPlaceholder}>Click eye to unhide your alias</Text>
                    ) : (
                            <Text style={styles.text}>{voterAlias}</Text>
                        )}
                    <TouchableOpacity onPress={() => { setIsAliasHidden(!isAliasHidden) }}>
                        <MaterialCommunityIcons name={isAliasHidden ? 'eye-off' : 'eye'} size={24} color={MainColors.primary} />
                    </TouchableOpacity>
                </View>

            </View>
        </ModalWrapper>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        width: '100%'
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
        paddingBottom: 10
    },
    title: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.darkGray,
        textAlign: 'center',
    },
    contentContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderWidth: 2,
        borderColor: MainColors.primary,
        borderRadius: 4,
        padding: 10,
        marginTop: 15,
    },
    hiddenPlaceholder: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.small,
        fontWeight: '600',
    },
    text: {
        color: MainColors.darkGray,
        fontSize: FontSizes.small,
        fontWeight: '600',
    }
});

export default VotingAliasModal;